<template>
    <div v-if="details">
        <b-tabs pills card vertical>
            <b-tab title="Vukuat Bilgileri" active>
                <b-card-text>
                    <h5>Temel Bilgiler</h5>
                    <table class="table table-sm table-striped table-bordered mb-2">
                        <tbody>
                            <tr>
                                <th class="w-50">Durum</th>
                                <td>
                                    <b-badge :variant="statusVariant">{{ details.StatusName || "Bilinmiyor" }}</b-badge>
                                </td>
                            </tr>
                            <tr>
                                <th>Vukuat Tarihi</th>
                                <td>{{ details.Date | dateFormatter }}</td>
                            </tr>
                            <tr>
                                <th>Fatura Numarası</th>
                                <td>{{ details.InvoiceNumber || "-" }}</td>
                            </tr>
                        </tbody>
                    </table>

                    <h5>Finansal Detaylar</h5>
                    <table class="table table-sm table-striped table-bordered">
                        <tbody>
                            <tr>
                                <th class="w-50">Toplam Vukuat Tutarı (TL)</th>
                                <td class="font-weight-bold">{{ details.TotalAmountStr || "0,00" }}</td>
                            </tr>
                            <tr>
                                <th>Personele Yansıtılan (TL)</th>
                                <td>{{ details.EmployeeAmountStr }}</td>
                            </tr>
                            <tr>
                                <th>Firmanın Karşıladığı (TL)</th>
                                <td>{{ details.CompanyAmountStr }}</td>
                            </tr>
                            <tr>
                                <th>Personel Emanet Tutarı (TL)</th>
                                <td>{{ details.EmployeeDepositAmountStr }}</td>
                            </tr>
                            <tr>
                                <th>Kalan Bakiye (TL)</th>
                                <td>{{ details.RemainingAmountStr }}</td>
                            </tr>
                        </tbody>
                    </table>
                </b-card-text>
            </b-tab>

            <b-tab title="Personel ve Araç">
                <b-card-text>
                    <h5>Personel Bilgileri</h5>
                    <table class="table table-sm table-striped table-bordered mb-2">
                        <tbody>
                            <tr>
                                <th class="w-35">Personel</th>
                                <td>{{ details.FullName || "-" }}</td>
                            </tr>
                            <tr>
                                <th>Şube</th>
                                <td>{{ details.EmployeeBranchName || "-" }}</td>
                            </tr>
                            <tr>
                                <th>Görev Yeri</th>
                                <td>{{ details.VehicleInventoryGarageName || "-" }}</td>
                            </tr>
                        </tbody>
                    </table>

                    <h5>Araç Bilgileri</h5>
                    <table class="table table-sm table-striped table-bordered">
                        <tbody>
                            <tr>
                                <th class="w-35">Çekici Plaka</th>
                                <td>{{ details.TruckPlate || "-" }}</td>
                            </tr>
                            <tr>
                                <th>Treyler Plaka</th>
                                <td>{{ details.TrailerPlate || "-" }}</td>
                            </tr>
                        </tbody>
                    </table>
                </b-card-text>
            </b-tab>

            <b-tab title="Açıklama ve Dosyalar">
                <b-card-text>
                    <h5>Açıklama</h5>
                    <p class="card-text">{{ details.Description || "Açıklama bulunmamaktadır." }}</p>
                    <h5 class="mt-2">Ekli Dosyalar</h5>
                    <div v-if="details.Files && details.Files.length > 0">
                        <ul class="list-group">
                            <li v-for="(fileUrl, index) in details.Files" :key="index" class="list-group-item">
                                <a :href="fileUrl" target="_blank" class="d-flex align-items-center"> <feather-icon icon="FileTextIcon" class="mr-50" /> {{ getFileName(fileUrl) }} </a>
                            </li>
                        </ul>
                    </div>
                    <div v-else>
                        <p>Dosya eki bulunmamaktadır.</p>
                    </div>
                </b-card-text>
            </b-tab>

            <b-tab title="Taksitler" :disabled="!details.IncidentInstallments || details.IncidentInstallments.length === 0">
                <b-card-text>
                    <h5>Ödeme Planı</h5>
                    <table class="table table-sm table-striped table-bordered">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Beklenen Ödeme Tarihi</th>
                                <th class="text-right">Tutar (TL)</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="installment in details.IncidentInstallments" :key="installment.Id">
                                <td>{{ installment.InstallmentOrder }}</td>
                                <td>{{ installment.ExpectedPeriod }}</td>
                                <td class="text-right">{{ installment.TotalAmountStr || "0,00" }}</td>
                            </tr>
                        </tbody>
                    </table>
                </b-card-text>
            </b-tab>

            <b-tab title="Değişiklik Geçmişi">
                <table class="table table-sm table-striped table-bordered mb-0">
                    <thead>
                        <th class="text-primary">Değişiklik İstenen Alan</th>
                        <th class="text-danger">Eski Değer</th>
                        <th class="text-success">Yeni Değer</th>
                    </thead>
                    <tbody>
                        <tr v-for="d in changeRequests" :key="d.Key">
                            <th class="w-50">{{ d.Key }}</th>
                            <td class="font-weight-bold">{{ d.OldValue }}</td>
                            <td class="font-weight-bold">{{ d.NewValue }}</td>
                        </tr>
                    </tbody>
                </table>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
import { BAlert, BTabs, BTab, BCardText, BBadge } from "bootstrap-vue";

export default {
    components: {
        BAlert,
        BTabs,
        BTab,
        BCardText,
        BBadge,
    },
    props: {
        details: {
            type: Object,
            default: null,
        },
        changeRequests:{
            type: Array,
            default: () => []
        }
    },
    computed: {
        statusVariant() {
            const status = this.details?.Status;
            switch (status) {
                case 0:
                    return "light-warning";
                case 1:
                    return "light-info";
                case 2:
                    return "light-success";
                case 3:
                    return "light-secondary";
                case 4:
                    return "light-info";
                default:
                    return "light";
            }
        },
    },
    methods: {
        getFileName(url) {
            if (!url) return "Bilinmeyen Dosya";
            return url.substring(url.lastIndexOf("/") + 1);
        },
    },
    filters: {
        currency(value) {
            if (typeof value !== "number") return value || "0,00 ₺";
            return value.toLocaleString("tr-TR", { style: "currency", currency: "TRY" });
        },
        dateFormatter(value) {
            if (!value) return "-";
            try {
                return new Date(value).toLocaleDateString("tr-TR");
            } catch (e) {
                return value;
            }
        },
    },
};
</script>
